import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12825e31"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "accountInfo" }
const _hoisted_2 = {
  key: 0,
  class: "accountInfo__closedBar"
}
const _hoisted_3 = { class: "accountInfo__closedItem" }
const _hoisted_4 = { class: "accountInfo__closedHeader" }
const _hoisted_5 = { class: "accountInfo__headMainTxt" }
const _hoisted_6 = {
  class: "accountInfo__headTxt",
  style: {"margin-left":"5px"}
}
const _hoisted_7 = { class: "accountInfo__headTxt" }
const _hoisted_8 = { class: "accountInfo__closedItem" }
const _hoisted_9 = { class: "accountInfo__closedHeader" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "accountInfo__headMainTxt" }, "KYC level", -1 /* HOISTED */))
const _hoisted_11 = { class: "accountInfo__headTxt" }
const _hoisted_12 = { class: "accountInfo__closedItem" }
const _hoisted_13 = { class: "accountInfo__closedHeader" }
const _hoisted_14 = { class: "accountInfo__headMainTxt" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "accountInfo__headTxt" }, "No", -1 /* HOISTED */))
const _hoisted_16 = { class: "accountInfo__closedItem" }
const _hoisted_17 = { class: "accountInfo__closedHeader" }
const _hoisted_18 = { class: "accountInfo__headMainTxt" }
const _hoisted_19 = {
  key: 0,
  class: "accountInfo__headTxt"
}
const _hoisted_20 = {
  key: 1,
  class: "accountInfo__headTxt"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.5 11.25L15 18.75L22.5 11.25",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = {
  key: 1,
  style: {"width":"100%","transition":".4s linear"}
}
const _hoisted_24 = { style: {"display":"flex","flex-direction":"row","justify-content":"space-between"} }
const _hoisted_25 = { class: "accountInfo__head" }
const _hoisted_26 = { class: "accountInfo__headMainTxt" }
const _hoisted_27 = { class: "accountInfo__headTxt" }
const _hoisted_28 = { class: "accountInfo__headTxt" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "30",
  viewBox: "0 0 30 30",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M7.5 11.25L15 18.75L22.5 11.25",
    stroke: "black",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1 /* HOISTED */))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "accountInfo__line" }, null, -1 /* HOISTED */))
const _hoisted_32 = { class: "accountInfo__body" }
const _hoisted_33 = { class: "accountInfo__head" }
const _hoisted_34 = { class: "accountInfo__headMainTxt" }
const _hoisted_35 = { class: "accountInfo__headTxt" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "accountInfo__line" }, null, -1 /* HOISTED */))
const _hoisted_37 = { class: "accountInfo__body" }
const _hoisted_38 = { class: "accountInfo__head" }
const _hoisted_39 = { class: "accountInfo__headMainTxt" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "accountInfo__line" }, null, -1 /* HOISTED */))
const _hoisted_41 = { class: "accountInfo__body" }
const _hoisted_42 = { class: "accountInfo__head" }
const _hoisted_43 = { class: "accountInfo__headMainTxt" }
const _hoisted_44 = {
  key: 0,
  style: {"white-space":"nowrap"},
  class: "accountInfo__headTxt"
}
const _hoisted_45 = {
  key: 1,
  class: "accountInfo__headTxt invalid"
}
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "accountInfo__line" }, null, -1 /* HOISTED */))
const _hoisted_47 = { class: "accountInfo__body" }
const _hoisted_48 = { class: "accountInfo__head" }
const _hoisted_49 = { class: "accountInfo__headMainTxt" }
const _hoisted_50 = {
  key: 0,
  style: {"white-space":"nowrap"},
  class: "accountInfo__headTxt"
}
const _hoisted_51 = {
  key: 1,
  class: "accountInfo__headTxt invalid"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (!$setup.open && $setup.showClosedTab)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('PROFILE_VIEW.YOUR_ACCOUNT')), 1 /* TEXT */),
                _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('PROFILE_VIEW.TYPE')) + ": " + _toDisplayString($setup.getLoginType()), 1 /* TEXT */)
              ]),
              _createElementVNode("div", _hoisted_7, "Email: " + _toDisplayString($setup.useUserServiceStore().userEmail), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode($setup["TooltipComponent"], {
                  style: {"z-index":"50"},
                  "tooltip-text": 'aaa'
                })
              ]),
              _createElementVNode("div", _hoisted_11, "Level " + _toDisplayString($setup.useUserServiceStore().getKycTier), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$t('PROFILE_VIEW.TERMS_ACCEPTANCE')), 1 /* TEXT */)
              ]),
              _hoisted_15
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.$t('PROFILE_VIEW.CLAIMER_ADDRESS')), 1 /* TEXT */)
              ]),
              ($setup.address)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString($setup.address), 1 /* TEXT */))
                : (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_ctx.$t('PROFILE_VIEW.NO_ADDRESS_PROVIDED')), 1 /* TEXT */))
            ]),
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.open = !$setup.open)),
              class: "accountInfo__closedItem accountInfo__arrow"
            }, [..._hoisted_22])
          ]))
        : _createCommentVNode("v-if", true),
      ($setup.open)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("p", _hoisted_26, _toDisplayString(_ctx.$t('PROFILE_VIEW.YOUR_ACCOUNT')), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('PROFILE_VIEW.TYPE')) + ": " + _toDisplayString($setup.getLoginType()), 1 /* TEXT */),
                _createElementVNode("p", _hoisted_28, "Email: " + _toDisplayString($setup.useUserServiceStore().userEmail), 1 /* TEXT */)
              ]),
              _createElementVNode("div", null, [
                _createVNode($setup["Button"], {
                  class: "p-button p-component secondary accountInfo__btn",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.router.push('/profile/changepassword')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.CHANGE_PASSWORD')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ]),
              ($setup.showClosedTab)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.open = !$setup.open)),
                    class: "accountInfo__closedItem accountInfo__arrow accountInfo__arrow-rotate"
                  }, [..._hoisted_30]))
                : _createCommentVNode("v-if", true)
            ]),
            _hoisted_31,
            _createElementVNode("div", _hoisted_32, [
              _createElementVNode("div", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createElementVNode("p", null, [
                    _createVNode($setup["TooltipComponent"], {
                      style: {"z-index":"50"},
                      "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.KYC')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('PROFILE_VIEW.KYC_LEVEL')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["tooltip-text"])
                  ])
                ]),
                _createElementVNode("p", _hoisted_35, _toDisplayString(_ctx.$t('PROFILE_VIEW.LEVEL')) + " " + _toDisplayString($setup.useUserServiceStore().getKycTier), 1 /* TEXT */)
              ]),
              _createElementVNode("div", null, [
                _createVNode($setup["Button"], {
                  class: "p-button p-component secondary accountInfo__btn",
                  onClick: $setup.onKycStart
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.START_KYC')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                })
              ])
            ]),
            _hoisted_36,
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("div", _hoisted_39, [
                  _createElementVNode("p", null, [
                    _createVNode($setup["TooltipComponent"], {
                      style: {"z-index":"50"},
                      "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.TERMS')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('PROFILE_VIEW.TERMS_ACCEPTANCE')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["tooltip-text"])
                  ])
                ]),
                _createElementVNode("p", {
                  class: _normalizeClass(["accountInfo__headTxt", {invalid: !$setup.isTermsAccepted }])
                }, _toDisplayString($setup.isTermsAccepted ? _ctx.$t('PROFILE_VIEW.ACCEPTED') : _ctx.$t('PROFILE_VIEW.NOT_ACCEPTED')), 3 /* TEXT, CLASS */)
              ]),
              _createElementVNode("div", null, [
                _createVNode($setup["Button"], {
                  class: "p-button p-component secondary accountInfo__btn",
                  disabled: $setup.isTermsAccepted,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('openApproval')))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.ACCEPT')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ])
            ]),
            _hoisted_40,
            _createElementVNode("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createElementVNode("p", null, [
                    _createVNode($setup["TooltipComponent"], {
                      style: {"z-index":"50"},
                      "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.CLAIMER_ADDRESS'),
                      "tooltip-link": "https://docs.c4e.io/usersGuide/auth.html"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('PROFILE_VIEW.CLAIMER_ADDRESS')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["tooltip-text"])
                  ])
                ]),
                ($setup.claimAddress)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_44, [
                      _createTextVNode(_toDisplayString($setup.addDotsInsideTooLongString($setup.claimAddress, 12)) + " ", 1 /* TEXT */),
                      _createVNode($setup["IconComponent"], {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.onCopy($setup.claimAddress))),
                        name: "Copy",
                        class: "copy",
                        style: {"margin-left":"5px"}
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_45, _toDisplayString(_ctx.$t('PROFILE_VIEW.NO_ADDRESS_PROVIDED')), 1 /* TEXT */))
              ]),
              _createElementVNode("div", null, [
                _createVNode($setup["Button"], {
                  disabled: !$setup.isLogedInInService || $setup.claimAddress != undefined,
                  class: "p-button p-component secondary accountInfo__btn",
                  onClick: $setup.provideClaimerAddress
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.PROVIDE_ADDRESS')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ])
            ]),
            _hoisted_46,
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _createElementVNode("div", _hoisted_49, [
                  _createElementVNode("p", null, [
                    _createVNode($setup["TooltipComponent"], {
                      style: {"z-index":"50"},
                      "tooltip-text": $setup.i18n.t('TOOLTIPS.HINTS.SOURCE_ADDRESS')
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('PROFILE_VIEW.SOURCE_ADDRESS')), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["tooltip-text"])
                  ])
                ]),
                ($setup.sourceAddress)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_50, [
                      _createTextVNode(_toDisplayString($setup.addDotsInsideTooLongString($setup.sourceAddress, 12)) + " ", 1 /* TEXT */),
                      _createVNode($setup["IconComponent"], {
                        onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.onCopy($setup.sourceAddress))),
                        class: "copy",
                        name: "Copy",
                        style: {"margin-left":"5px"}
                      })
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_51, _toDisplayString(_ctx.$t('PROFILE_VIEW.NO_ADDRESS_PROVIDED')), 1 /* TEXT */))
              ]),
              _createElementVNode("div", null, [
                _createVNode($setup["Button"], {
                  disabled: !$setup.isLogedInInService || $setup.sourceAddress != undefined,
                  class: "p-button p-component secondary accountInfo__btn",
                  onClick: $setup.provideSourceAddress
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('BUTTONS.PROVIDE_ADDRESS')), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["disabled"])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    ($setup.loginPopupStatus)
      ? (_openBlock(), _createBlock($setup["LoginPopUp"], {
          key: 0,
          showAddressOption: false,
          onClose: _cache[6] || (_cache[6] = ($event: any) => ($setup.loginPopupStatus =! $setup.loginPopupStatus)),
          onConnected: _cache[7] || (_cache[7] = ($event: any) => ($setup.onShowInfoModal($setup.AddressType.KEPLR)))
        }))
      : _createCommentVNode("v-if", true),
    _createVNode($setup["ProvideAddresInfoModal"], {
      "address-type": $setup.showAddressInfoModalAddressType,
      address: $setup.showAddressInfoModalAddressType == $setup.AddressType.METAMASK ? $setup.useUserStore().metamaskConnectionInfo.address : $setup.c4eAddress,
      display: $setup.showAddressInfoModal,
      onConfirm: $setup.addressConfirmed,
      onClose: $setup.closeProvideAddressModalClose
    }, null, 8 /* PROPS */, ["address-type", "address", "display"])
  ], 64 /* STABLE_FRAGMENT */))
}